import { Box, Dialog, DialogActions, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Diálogo curto de status/confirmação: ícone num círculo tingido, título,
 * descrição opcional e ações centralizadas. Base dos diálogos de sucesso,
 * erro e confirmação de exclusão.
 *
 * `color`: cor da paleta usada no ícone e no título ("success" | "error" | "warning" | "primary").
 */
export default function StatusDialog({ open, onClose, color = 'primary', icon, title, description, actions, titleId }) {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby={titleId} fullWidth maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          pt: 4,
          pb: 2,
          px: 3,
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            'width': 72,
            'height': 72,
            'borderRadius': '50%',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'center',
            'color': `${color}.main`,
            'bgcolor': (theme) => alpha(theme.palette[color].main, 0.1),
            '& svg': { fontSize: 40 },
          }}
        >
          {icon}
        </Box>
        <Typography id={titleId} variant="h6" sx={{ mt: 1 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" component="div" sx={{ maxWidth: 360 }}>
            {description}
          </Typography>
        )}
      </Box>
      <DialogActions sx={{ justifyContent: 'center', gap: 1, px: 3, pb: 3, pt: 1 }}>{actions}</DialogActions>
    </Dialog>
  );
}
